import React, { useState, useEffect } from 'react';
import './pactometro.scss';

import {

  useRESTDataCache,

  ResultProvider,
  getResultOrigin
} from '@atresmedia/elections_modules_library/dist/dataProvider';
import {
  TYPES,
  SUBTYPES
} from '@atresmedia/elections_modules_library/dist/envs';
import Cintillo from '@atresmedia/elections_modules_library/dist/components/cintillo';
import PactometroCheck from '@atresmedia/elections_modules_library/dist/components/pactometroCheck';
import PactometroCheckSimple from '@atresmedia/elections_modules_library/dist/components/pactometroCheck/pactometroCheckSimple';
import { getSite } from '../moduleGenerator/utils';
import { PROPERTIES_JSON } from '../../core/constants';

const Pactometro = ({ match, simple }) => {
  const { year, type, electionNumber, placesIds, community } = match.params;

  const [resultOrigin, setResultOrigin] = useState({});

  const [selectedTarget, setSelectedTarget] = useState(null);
  const params = useRESTDataCache(PROPERTIES_JSON(), 'GLOBAL_CONFIG', null);
  useEffect(() => {
    if (params) {
      const selected = params.targets.find((tt) => tt.ineId === community);
      setSelectedTarget(selected);
    }
  }, [params]);

  useEffect(() => {
    getResultOrigin(
      year,
      type,
      electionNumber,
      type === TYPES.REGIONAL ? community : placesIds
    )
      .then((historicResult) => {
        setResultOrigin(historicResult);
      })
      .catch((err) => {});
  }, [year, type, electionNumber, placesIds, community]);
  const site = getSite();

  if (!params || !selectedTarget) {
    return <div>loading...</div>;
  }
  return (
    <div className="pagePactometro">
      <Cintillo
        title={`ELECCIONES ${selectedTarget.name.toLocaleUpperCase()} 2021`}
        backgroundColor={selectedTarget.backgroundColor[site]}
        imgProps={{
          src: selectedTarget.flags.default,
          alt: `Bandera de ${selectedTarget.Name}`,
        }}
        rightSide={params.sites[site].labels.pactos}
      ></Cintillo>
      {resultOrigin && resultOrigin.primary && (
        <ResultProvider
          electionPlace={type === TYPES.REGIONAL ? community : placesIds}
          active={resultOrigin.primary.active}
          year={year}
          type={type}
          subtype={type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE}
          electionNumber={electionNumber}
          placeId={type === TYPES.REGIONAL ? community : placesIds}
        >
          {(dataResult) =>
            dataResult.partiesResult && dataResult.totalSeats ? (
              simple ? (
                <PactometroCheckSimple
                  seatData={dataResult.partiesResult}
                  totalSeat={dataResult.totalSeats}
                />
              ) : (
                <PactometroCheck
                  seatData={dataResult.partiesResult}
                  totalSeat={dataResult.totalSeats}
                />
              )
            ) : (
              <p>Cargando</p>
            )
          }
        </ResultProvider>
      )}
    </div>
  );
};

export default Pactometro;
